import React from 'react';
import { Text } from 'components/text/Text';
import { TextBlock } from 'components/text-block/TextBlock';
import { Divider } from 'components/elements/divider/Divider';

export const Component = () => {
  const text =
    'We are specialists in biopharmaceutical product creation, all along the value chain from cell line development to commercial manufacturing. Our common goal is to be a global leader in the biosimilar space and to deliver high quality cost competitive products to patients worldwide. We come from all around the world, bringing literally thousands of years of combined knowledge and expertise to our mission.';

  const boxContent = <p>{text}</p>;

  const asideContent = (
    <>
      <p>
        <b>Fully in-house R&amp;D and manufacturing provide:</b>
      </p>
      <ol>
        <li>
          Cutting-edge in-house R&amp;D capabilities, from cell line, process and product
          development through process scale-up and manufacturing are completed by a fully integrated
          clinical and regulatory function, allowing a smooth transition from development through
          global launch and commercial manufacturing.
        </li>
        <li>
          State-of-the-art facility for drug substance and drug product manufacturing of biologics,
          complimented by QC laboratories.
        </li>
        <li>
          Robust manufacturing processes such as single use-technology, reducing the need to clean
          and sterilize equipment and allowing flexibility and multiproduct manufacturing.
        </li>
      </ol>
    </>
  );

  return (
    <>
      <Divider>TextBlock with brand box color</Divider>
      <TextBlock
        tagline="With a tagline"
        title="Text block title"
        text={boxContent}
        color="brand"
        isSlice
        textLength={text.length}
      >
        <Text text={asideContent} hasLayout={false} />
      </TextBlock>
      <Divider>TextBlock with brand box color &amp; no side content</Divider>
      <TextBlock
        tagline="With a tagline"
        title="Text block title"
        text={boxContent}
        color="brand"
        isSlice
        textLength={text.length}
      />
      <Divider>TextBlock with dark box color</Divider>
      <TextBlock
        tagline="With a tagline"
        title="Substantially longer text block title"
        text={boxContent}
        color="dark"
        isSlice
        textLength={text.length}
      >
        <Text text={asideContent} hasLayout={false} />
      </TextBlock>
      <Divider>TextBlock with white box color</Divider>
      <TextBlock
        tagline="With a tagline"
        title="Substantially longer text block title"
        text={boxContent}
        color="white"
        isSlice
        textLength={text.length}
      >
        <Text text={asideContent} hasLayout={false} />
      </TextBlock>
      <Divider>TextBlock without box</Divider>
      <TextBlock
        tagline="With a tagline"
        title="Text block title"
        text={boxContent}
        isSlice
        textLength={text.length}
      >
        <Text text={asideContent} hasLayout={false} />
      </TextBlock>
      <Divider>TextBlock without box &amp; no side content</Divider>
      <TextBlock
        tagline="With a tagline"
        title="Substantially longer text block title"
        text={boxContent}
        isSlice
        textLength={text.length}
      />
    </>
  );
};
